var _classCallCheck = require("/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
var _defineProperty = require("/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(typeof e + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
!function (e, r) {
  "object" == typeof exports && "object" == typeof module ? module.exports = r() : "function" == typeof define && define.amd ? define([], r) : "object" == typeof exports ? exports.Morphism = r() : e.Morphism = r();
}(this, function () {
  return function (e) {
    var r = {};
    function t(n) {
      if (r[n]) return r[n].exports;
      var o = r[n] = {
        i: n,
        l: !1,
        exports: {}
      };
      return e[n].call(o.exports, o, o.exports, t), o.l = !0, o.exports;
    }
    return t.m = e, t.c = r, t.d = function (e, r, n) {
      t.o(e, r) || Object.defineProperty(e, r, {
        enumerable: !0,
        get: n
      });
    }, t.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, t.t = function (e, r) {
      if (1 & r && (e = t(e)), 8 & r) return e;
      if (4 & r && "object" == typeof e && e && e.__esModule) return e;
      var n = Object.create(null);
      if (t.r(n), Object.defineProperty(n, "default", {
        enumerable: !0,
        value: e
      }), 2 & r && "string" != typeof e) for (var o in e) t.d(n, o, function (r) {
        return e[r];
      }.bind(null, o));
      return n;
    }, t.n = function (e) {
      var r = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return t.d(r, "a", r), r;
    }, t.o = function (e, r) {
      return Object.prototype.hasOwnProperty.call(e, r);
    }, t.p = "", t(t.s = 0);
  }([function (e, r, t) {
    "use strict";

    function n(e, r) {
      var t = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        r && (n = n.filter(function (r) {
          return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, n);
      }
      return t;
    }
    function o(e, r, t) {
      return r in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[r] = t, e;
    }
    t.r(r);
    var i = Symbol.for("SchemaOptions");
    function a(e) {
      return h(e) && e.hasOwnProperty("fn") && e.hasOwnProperty("path");
    }
    function c(e) {
      return l(e);
    }
    function u(e) {
      return Array.isArray(e) && e.every(c);
    }
    var s,
      p = function p(e, r) {
        return e.reduce(function (e, t) {
          return b(e, t, g(r, t)), e;
        }, {});
      };
    function f(e) {
      return void 0 === e;
    }
    function h(e) {
      var r = typeof e;
      return null != e && ("object" === r || "function" === r);
    }
    function l(e) {
      return "string" == typeof e || e instanceof String;
    }
    function d(e) {
      return "function" == typeof e;
    }
    function y(e) {
      if (Promise && Promise.resolve) return Promise.resolve(e) == e;
      throw "Promise not supported in your environment";
    }
    function g(e, r) {
      for (var t = (r = (r = r.replace(/\[(\w+)\]/g, ".$1")).replace(/^\./, "")).split("."), n = 0, o = t.length; n < o; ++n) {
        var i = t[n];
        if (!(h(e) && i in e)) return;
        e = e[i];
      }
      return e;
    }
    function m(e, r) {
      return e.reduce(function (e, t, i) {
        return function (e) {
          for (var r = 1; r < arguments.length; r++) {
            var t = null != arguments[r] ? arguments[r] : {};
            r % 2 ? n(t, !0).forEach(function (r) {
              o(e, r, t[r]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : n(t).forEach(function (r) {
              Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
            });
          }
          return e;
        }({}, e, _defineProperty({}, t, r[i]));
      }, {});
    }
    function v(e, r) {
      return "number" == typeof r && Array.isArray(e) || function (e, r) {
        return null != e && Object.prototype.hasOwnProperty.call(e, r);
      }(e, r);
    }
    function b(e, r, t, n) {
      if ("number" == typeof r && (r = [r]), !r || 0 === r.length) return e;
      if ("string" == typeof r) return b(e, r.split(".").map(P), t, n);
      var o = r[0],
        i = function (e, r) {
          if (v(e, r)) return e[r];
        }(e, o);
      return 1 === r.length ? (void 0 !== i && n || (e[o] = t), i) : (void 0 === i && ("number" == typeof r[1] ? e[o] = [] : e[o] = {}), b(e[o], r.slice(1), t, n));
    }
    function P(e) {
      var r = parseInt(e);
      return r.toString() === e ? r : e;
    }
    function O(e, r) {
      var t = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        r && (n = n.filter(function (r) {
          return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, n);
      }
      return t;
    }
    function j(e) {
      for (var r = 1; r < arguments.length; r++) {
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? O(t, !0).forEach(function (r) {
          w(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : O(t).forEach(function (r) {
          Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
      }
      return e;
    }
    function w(e, r, t) {
      return r in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[r] = t, e;
    }
    function S(e, r) {
      return r && !function (e) {
        for (var r in e) if (Object.prototype.hasOwnProperty.call(e, r)) return !1;
        return !0;
      }(r) && (e[i] = r), e;
    }
    !function (e) {
      e.Root = "Root", e.Property = "Property", e.ActionFunction = "ActionFunction", e.ActionAggregator = "ActionAggregator", e.ActionString = "ActionString", e.ActionSelector = "ActionSelector";
    }(s || (s = {}));
    var A = /*#__PURE__*/function () {
      function A(e) {
        _classCallCheck(this, A);
        this.schemaOptions = void 0, this.root = void 0, this.schema = void 0, this.schema = e, this.schemaOptions = A.getSchemaOptions(this.schema), this.root = {
          data: {
            targetPropertyPath: "",
            propertyName: "MorphismTreeRoot",
            action: null,
            kind: s.Root
          },
          parent: null,
          children: []
        }, e && this.parseSchema(e);
      }
      _createClass(A, [{
        key: "parseSchema",
        value: function parseSchema(e, r, t) {
          var _this = this;
          var n;
          (l(n = e) || d(n) || a(n) || u(n)) && r ? (this.add({
            propertyName: r,
            action: e
          }, t), t = t ? "".concat(t, ".").concat(r) : r) : (r && (this.add({
            propertyName: r,
            action: null
          }, t), t = t ? "".concat(t, ".").concat(r) : r), Array.isArray(e) ? e.forEach(function (e, r) {
            _this.parseSchema(e, r.toString(), t);
          }) : h(e) && Object.keys(e).forEach(function (r) {
            _this.parseSchema(e[r], r, t);
          }));
        }
      }, {
        key: "traverseBFS",
        value: /*#__PURE__*/_regeneratorRuntime().mark(function traverseBFS() {
          var e, r, t, n;
          return _regeneratorRuntime().wrap(function traverseBFS$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                e = [];
                e.push(this.root);
              case 2:
                if (!(e.length > 0)) {
                  _context.next = 13;
                  break;
                }
                r = e.shift();
                if (r) {
                  _context.next = 6;
                  break;
                }
                return _context.abrupt("return");
              case 6:
                for (t = 0, n = r.children.length; t < n; t++) e.push(r.children[t]);
                _context.t0 = r.data.kind !== s.Root;
                if (!_context.t0) {
                  _context.next = 11;
                  break;
                }
                _context.next = 11;
                return r;
              case 11:
                _context.next = 2;
                break;
              case 13:
              case "end":
                return _context.stop();
            }
          }, traverseBFS, this);
        })
      }, {
        key: "add",
        value: function add(e, r) {
          var t = this.getActionKind(e.action);
          if (!t) throw new Error("The action specified for ".concat(e.propertyName, " is not supported."));
          var n = {
            data: j({}, e, {
              kind: t,
              targetPropertyPath: ""
            }),
            parent: null,
            children: []
          };
          if (n.data.preparedAction = this.getPreparedAction(n.data), r) {
            var _iterator = _createForOfIteratorHelper(this.traverseBFS()),
              _step;
            try {
              for (_iterator.s(); !(_step = _iterator.n()).done;) {
                var o = _step.value;
                o.data.targetPropertyPath === r && (n.parent = o, n.data.targetPropertyPath = "".concat(o.data.targetPropertyPath, ".").concat(n.data.propertyName), o.children.push(n));
              }
            } catch (err) {
              _iterator.e(err);
            } finally {
              _iterator.f();
            }
          } else n.parent = this.root, n.data.targetPropertyPath = n.data.propertyName, this.root.children.push(n);
        }
      }, {
        key: "getActionKind",
        value: function getActionKind(e) {
          return c(e) ? s.ActionString : d(e) ? s.ActionFunction : a(e) ? s.ActionSelector : u(e) ? s.ActionAggregator : null === e ? s.Property : void 0;
        }
      }, {
        key: "getPreparedAction",
        value: function getPreparedAction(e) {
          var r = e.propertyName,
            t = e.action,
            n = e.kind;
          if (c(t)) return function (e) {
            var r = e.object;
            return g(r, t);
          };
          if (d(t)) return function (e) {
            var r = e.object,
              n = e.items,
              o = e.objectToCompute;
            return t.call(void 0, r, n, o);
          };
          if (u(t)) return function (e) {
            var r = e.object;
            return p(t, r);
          };
          if (a(t)) return function (e) {
            var n,
              o = e.object,
              i = e.items,
              a = e.objectToCompute;
            try {
              var c;
              Array.isArray(t.path) ? c = p(t.path, o) : l(t.path) && (c = g(o, t.path)), n = t.fn.call(void 0, c, o, i, a);
            } catch (e) {
              throw e.message = "Unable to set target property [".concat(r, "].\n                                        \n An error occured when applying [").concat(t.fn.name, "] on property [").concat(t.path, "]\n                                        \n Internal error: ").concat(e.message), e;
            }
            return n;
          };
          if (n === s.Property) return null;
          throw new Error("The action specified for ".concat(r, " is not supported."));
        }
      }], [{
        key: "getSchemaOptions",
        value: function getSchemaOptions(e) {
          return j({}, {
            class: {
              automapping: !0
            },
            undefinedValues: {
              strip: !1
            }
          }, {}, e ? e[i] : void 0);
        }
      }]);
      return A;
    }();
    function M(e) {
      return function (r, t, n) {
        var o = n.value;
        return "function" == typeof o && (n.value = function () {
          for (var r = arguments.length, t = new Array(r), n = 0; n < r; n++) t[n] = arguments[n];
          var i = o.apply(this, t);
          return y(i) ? Promise.resolve(i).then(function (r) {
            return e(r);
          }) : e(i);
        }), n;
      };
    }
    function _(e, r, t, n) {
      var o = r.schemaOptions,
        i = [];
      var _iterator2 = _createForOfIteratorHelper(r.traverseBFS()),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var a = _step2.value;
          var _a$data = a.data,
            c = _a$data.preparedAction,
            u = _a$data.targetPropertyPath;
          c && i.push({
            targetPropertyPath: u,
            preparedAction: c({
              object: e,
              objectToCompute: n,
              items: t
            })
          });
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      return i.reduce(function (e, r) {
        var t = function (e, r) {
          return f(r) ? f(e) ? void 0 : e : r;
        }(g(e, r.targetPropertyPath), r.preparedAction);
        return void 0 === t ? (o && o.undefinedValues && o.undefinedValues.strip ? o.undefinedValues.default && b(e, r.targetPropertyPath, o.undefinedValues.default(e, r.targetPropertyPath)) : b(e, r.targetPropertyPath, t), e) : (b(e, r.targetPropertyPath, t), e);
      }, n);
    }
    function E(e, r) {
      var t,
        n = A.getSchemaOptions(e);
      if (r && n.class && n.class.automapping) {
        var o = function (e, r) {
          var t = Object.keys(new e()),
            n = m(t, t);
          return Object.assign(n, r);
        }(r, e);
        t = new A(o);
      } else t = new A(e);
      return function (e) {
        if (!e) return e;
        if (Array.isArray(e)) return e.map(function (n) {
          if (r) {
            var o = new r();
            return _(n, t, e, o);
          }
          return _(n, t, e, {});
        });
        var n = e;
        if (r) {
          var o = new r();
          return _(n, t, [n], o);
        }
        return _(n, t, [n], {});
      };
    }
    function x(e, r, t) {
      switch (arguments.length) {
        case 1:
          return E(e);
        case 2:
          return E(e)(r);
        case 3:
          if (t) return null !== r ? E(e, t)(r) : E(e, t);
          throw new Error("When using morphism(schema, items, type), type should be defined but value received is ".concat(t));
      }
    }
    function T(e, r) {
      return M(E(e, r));
    }
    function k(e) {
      return M(E(e));
    }
    function D(e, r) {
      return M(E(e, r));
    }
    t.d(r, "morph", function () {
      return T;
    }), t.d(r, "toJSObject", function () {
      return k;
    }), t.d(r, "toClassObject", function () {
      return D;
    }), t.d(r, "morphism", function () {
      return x;
    }), t.d(r, "createSchema", function () {
      return S;
    }), t.d(r, "Schema", function () {}), t.d(r, "StrictSchema", function () {}), t.d(r, "SchemaOptions", function () {}), t.d(r, "Mapper", function () {}), t.d(r, "SCHEMA_OPTIONS_SYMBOL", function () {
      return i;
    });
    var N = new (/*#__PURE__*/function () {
        function _class(e) {
          _classCallCheck(this, _class);
          this._registry = null, this._registry = e || {
            cache: new Map()
          };
        }
        _createClass(_class, [{
          key: "register",
          value: function register(e, r) {
            if (!e && !r) throw new Error("type paramater is required when you register a mapping");
            if (this.exists(e)) throw new Error("A mapper for ".concat(e.name, " has already been registered"));
            var t;
            return t = x(r || {}, null, e), this._registry.cache.set(e, t), t;
          }
        }, {
          key: "map",
          value: function map(e, r) {
            if (!this.exists(e)) {
              var t = this.register(e);
              if (void 0 === r) return t;
            }
            return this.getMapper(e)(r);
          }
        }, {
          key: "getMapper",
          value: function getMapper(e) {
            return this._registry.cache.get(e);
          }
        }, {
          key: "setMapper",
          value: function setMapper(e, r) {
            if (r) {
              if (this.exists(e)) {
                var t = x(r, null, e);
                return this._registry.cache.set(e, t), t;
              }
              throw new Error("The type ".concat(e.name, " is not registered. Register it using `Mophism.register(").concat(e.name, ", schema)`"));
            }
            throw new Error("The schema must be an Object. Found ".concat(r));
          }
        }, {
          key: "deleteMapper",
          value: function deleteMapper(e) {
            return this._registry.cache.delete(e);
          }
        }, {
          key: "exists",
          value: function exists(e) {
            return this._registry.cache.has(e);
          }
        }, {
          key: "mappers",
          get: function get() {
            return this._registry.cache;
          }
        }]);
        return _class;
      }())(),
      F = x;
    F.register = function (e, r) {
      return N.register(e, r);
    }, F.map = function (e, r) {
      return N.map(e, r);
    }, F.getMapper = function (e) {
      return N.getMapper(e);
    }, F.setMapper = function (e, r) {
      return N.setMapper(e, r);
    }, F.deleteMapper = function (e) {
      return N.deleteMapper(e);
    }, F.mappers = N.mappers;
    var R = F;
    r.default = R;
  }]);
});